import React from 'react'

export default function Quote() {
  return (
    <div>
      <h1>Hello from Get Quote</h1>
    </div>
  )
}
